import React, { useContext, useEffect, useState } from "react";
import { Pagination, Autoplay } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import axios from "axios";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
const BlogHome = () => {
  const {loading,blog,error} = useContext(ApiLinkContext)
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <div
        className="section section-padding-bottom position-relative"
        style={{ background: "#F5F5F5" }}
      >
        <div className="container">
            
          {/* Section Title Start */}
          <div className="section-title text-center mt-5" >
            <h2 className="title text-uppercase">
              {t.news}
            </h2>
          </div>
          {/* Section Title End */}
          {/* Courses Wrapper Start */}
          <div className="courses-slider swiper-container" >
            <div>
              {/* Course Start */}
              <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={0}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                pagination={{ clickable: true }}
                // loop={true}
                // autoplay={{
                //   delay: 2800, 
                //   disableOnInteraction: false, 
                // }}
              >
                {blog.slice(0,12).map((item) => {
                  return (
                    <SwiperSlide>
                      <NavLink to={`/${slugify(`${item.id}-${item.name}`).toLowerCase()}`} >
                      <div className="swiper-s mb-30 mx-2 pb-5">
                        <div className="course box-shadow">
                          <div className="thumbnail">
                            <a
                              href="#"
                              className="image"
                            >
                              <img
                                src={item.img}
                                alt={item.name}
                                style={{
                                  width:"100%",
                                  height:"250px",
                                  objectFit:"cover"
                                }}
                              />
                            </a>
                          </div>
                          <div className="info">
                            <h3 className="title">
                              <a href="#">
                              {language == "az"
                                  ? item.name
                                  : language == "en"
                                  ? item.nameEn
                                  : language == "ru"
                                  ? item.nameRu
                                  : language == "tr"
                                  ? item.nameTr
                                  : language == "de"
                                  ? item.nameDe
                                  : language == "pl"
                                  ? item.namePl
                                  : ""}
                              </a>
                            </h3>
                            <p>
                            {item.descrip && 
                              
                              language == "az"
                                      ? item.descrip.slice(0, 81)
                                      : language == "en"
                                      ? item.descripEn.slice(0, 81)
                                      : language == "ru"
                                      ? item.descripRu.slice(0, 81)
                                      : language == "tr"
                                      ? item.descripTr.slice(0, 81)
                                      : language == "de"
                                      ? item.descripDe.slice(0, 81)
                                      : language == "pl"
                                      ? item.descripPl.slice(0, 81)
                                      : ""}
                            </p>
                            <ul className="meta">
                              <li>
                                <i className="fas fa-file-alt" />
                                {item.date} 
                              </li>
                              {
                                item.view > 0 && (
                              <li>
                                <i className="fas fa-user-alt" />
                                {item.view} Baxış 
                              </li>
                                )
                              }
                            </ul>
                          </div>
                        </div>
                      </div>
                      </NavLink>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* Course End */}
            </div>
          </div>
        </div>
        {/* Section Bottom Shape Start */}
        <div className="section-bottom-shape">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            height={100}
          >
            <path
              className="elementor-shape-fill"
              d="M 0 0 L0 100 L100 100 L100 0 Q 50 200 0 0"
            />
          </svg>
        </div>
        {/* Section Bottom Shape End */}
      </div>

    </>
  );
};

export default BlogHome;
